import { S2STag, UnitOfMeasure } from '@/models/s2s';

export interface S2SState {
  availableTags: S2STag[];
  isLoadingItems: boolean;
  isUploadingTags: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  licenses: any[]; // TODO: create an interface for this
  openPackageSubDrawerId: number | null;
  unitsOfMeasure: UnitOfMeasure[];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  categories: any[];
}

export const state: S2SState = {
  availableTags: [],
  isLoadingItems: false,
  licenses: [],
  openPackageSubDrawerId: null,
  isUploadingTags: false,
  unitsOfMeasure: [],
  categories: [],
};
